import {createSelector} from "reselect";

export const selectTabs2 = state =>  state.tabs2;

export const selectCurrentTab2 = createSelector(
    selectTabs2,
    tabs2 => tabs2.currentTab2
);
